import Asset from "@components/CustomTypography/Asset/Asset"
import Content, {
	ContentType,
} from "@components/CustomTypography/Content/Content"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import {direction} from "@customTypes/customTypes"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ContentAsset.module.scss"

export type ContentAssetNewProps = {
	data?: AdvancedSideAssetMainContent
	direction?: direction
	contentProps?: ContentType
	withAutoSizing?: boolean
	shortDesc?: number
	withAspectRation?: boolean
	mainContainerClass?: string
	scale?: {
		width: 4 | 16
		height: 3 | 9
	}
}

const ContentAsset = (props: ContentAssetNewProps) => {
	if (typeof props.data === "undefined") {
		return <></>
	}

	const directionMap = {
		right: styles.right,
		left: styles.left,
	}

	const direction = directionMap[props.direction || "right"] || styles.right

	const assetData = {...props.data.preview}

	return (
		<div
			className={` ${props.mainContainerClass} ${styles.assetContainer} ${direction}`}
			id={props.data.sectionid?.replace("#", "")}
		>
			<div className={styles.content}>
				<Content
					containerClassName={styles.containerClassName}
					data={props.data}
					shortDesc={props.shortDesc}
					{...props.contentProps}
					contentProps={{
						style: {
							marginTop: "2rem",
						},
						...props.contentProps?.contentProps,
					}}
					titleProps={{
						noPadding: true,
						...props.contentProps?.titleProps,
					}}
				/>
				{props.data.buttons?.length != null &&
					props.data.buttons?.length > 0 && (
						<ButtonContainer className={styles.content_buttons_box}>
							<ButtonSwitcher buttonsList={props.data} />
						</ButtonContainer>
					)}
			</div>
			<div className={styles.asset}>
				<Asset
					data={{
						...assetData,
						imageClassName: styles.imageClassName,
						style: {
							aspectRatio: props.withAspectRation
								? "16/9"
								: "auto",
						},
						alt: props?.data?.title ?? assetData.alt,
					}}
					type={
						props.data.preview?.type
							? props.data.preview?.type
							: "string"
					}
				/>
			</div>
		</div>
	)
}

export default ContentAsset
